import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

fetch('/config.json')
  .then(res => {
    if (!res.ok) throw new Error(`Failed to load config: ${res.status}`);
    return res.json();
  })
  .then(config => {
    window.__CONFIG__ = config;
    return import('./App');
  })
  .then(({ default: App }) => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>
    );
  })
  .catch(err => {
    console.error('App failed to start:', err);
    document.getElementById('root').innerHTML =
      '<p style="padding:2rem">Application failed to load configuration. Please contact support.</p>';
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
